import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { FlameIcon, CheckIcon, StarIcon } from './icons/Icons';
const HERO_BG = 'https://cdn.magicpatterns.com/patterns/generated-images/d8d10b79-d465-4647-bd26-634d9e411ccb.jpg';
const PRODUCT = 'https://cdn.magicpatterns.com/uploads/7T58E3TjTYgiqrvh4HrvYf/G-smart.png';
const bullets = ['Sin pastillas milagrosas', 'Sin dietas aburridas', 'Sin gastar una fortuna en especialistas'];
export function Hero() {
  return <header className="relative w-full overflow-hidden" data-id="element-105">
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url(${HERO_BG})`
    }} aria-hidden="true" data-id="element-106" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#f7f4ec]/70 via-[#f7f4ec]/85 to-[#f7f4ec]" aria-hidden="true" data-id="element-107" />

      <div className="relative mx-auto flex max-w-3xl flex-col items-center px-5 py-14 text-center sm:py-20" data-id="element-108">
        <Reveal data-id="element-109">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#e0611f]/30 bg-white/70 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-[#b1481a] backdrop-blur" data-id="element-110">
            <span className="animate-flicker" data-id="element-111">
              <FlameIcon className="h-4 w-4" strokeWidth={2.2} data-id="element-112" />
            </span>
            Método GastroSmart · Versión 2026
          </span>
        </Reveal>

        <Reveal delay={0.08} data-id="element-113">
          <h1 className="mt-5 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[#1f2a22] sm:text-5xl lg:text-6xl" data-id="element-114">
            Cómo{' '}
            <span className="relative inline-block" data-id="element-115">
              <span className="relative z-10 text-[#e0611f]" data-id="element-116">“Apagar”</span>
              <motion.span aria-hidden="true" className="absolute -bottom-1 left-0 z-0 h-3 w-full bg-amber-300/50" initial={{
              scaleX: 0
            }} animate={{
              scaleX: 1
            }} transition={{
              delay: 0.6,
              duration: 0.7,
              ease: 'easeOut'
            }} style={{
              transformOrigin: 'left'
            }} data-id="element-117" />
            </span>{' '}
            el Fuego de la Gastritis en menos de{' '}
            <span className="text-[#3f6b3a]" data-id="element-118">48 Horas</span> con 3 Alimentos que
            ya tienes en tu Despensa.
          </h1>
        </Reveal>

        <Reveal delay={0.16} data-id="element-119">
          <ul className="mt-6 flex flex-col items-center gap-2 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-5" data-id="element-120">
            {bullets.map(b => <li key={b} className="flex items-center gap-2 text-sm font-medium text-[#3d4a40] sm:text-base" data-id="element-121">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#3f6b3a] text-white" data-id="element-122">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-123" />
                </span>
                {b}
              </li>)}
          </ul>
        </Reveal>

        {/* Product mockup — placed above the CTA button */}
        <Reveal delay={0.2} className="flex justify-center" data-id="element-124">
          <motion.div initial={{
          opacity: 0,
          scale: 0.92,
          rotate: -3
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          delay: 0.3,
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative mt-9" data-id="element-125">
            <motion.div animate={{
            y: [0, -12, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative" data-id="element-126">
              <div className="absolute -inset-6 rounded-[2rem] bg-[#3f6b3a]/10 blur-2xl" aria-hidden="true" data-id="element-127" />
              <img src={PRODUCT} alt="Ebook Maestro GastroSmart: Tu Farmacia en la Despensa, mostrado en una tablet" className="relative w-56 rounded-2xl shadow-2xl sm:w-72" data-id="element-128" />
            </motion.div>
          </motion.div>
        </Reveal>

        <Reveal delay={0.28} data-id="element-129">
          <div className="mx-auto mt-9 w-full max-w-md" data-id="element-130">
            <CtaButton data-id="element-131" />
            <div className="mt-3 flex items-center justify-center gap-2 text-sm text-[#5a6b5c]" data-id="element-132">
              <span className="flex text-amber-500" data-id="element-133">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4" data-id="element-134" />)}
              </span>
              <span data-id="element-135">Miles de estómagos ya calmados</span>
            </div>
          </div>
        </Reveal>
      </div>
    </header>;
}